// list address panel
import Login from "@/panel/components/Login/index.vue";
import panelLoginLayout from "@/panel/components/Layout/loginLayout.vue";
import HomeView from "@/panel/views/HomeView.vue";
import panelDefaultLayout from "@/panel/components/Layout/index.vue";
import * as guards from "@/router/guard";
import Users from "@/panel/components/Users/index.vue";
import Excel from "@/panel/components/Uploads/Excel/index.vue";
import categories from "@/panel/components/Categories/index.vue";
import customer from "@/panel/components/Customers/index.vue";
import Answer from "@/panel/components/Customers/Results.vue";
import ListQuestions from "@/panel/components/ListQuestions/index.vue";
import CreateQuestions from "@/panel/components/CreateQuestions/index.vue";
import Settings from "@/panel/components/Settings/index.vue";
import Discount from "@/panel/views/discount/index.vue"

export const panelRoutes = [

    {
        path: '/panel',
        name: 'PanelLogin',
        component: Login,
        meta: {layout: panelLoginLayout},
    },
    {
        path: '/panel/dashboard',
        name: 'dashboard',
        component: HomeView,
        meta: {layout: panelDefaultLayout},
        beforeEnter: guards.paranGuards,

    },
    {
        path: '/panel/users',
        name: 'users',
        component: Users,
        meta: {layout: panelDefaultLayout},
        beforeEnter: guards.paranGuards,

    },
    {
        path: '/panel/upload/excel',
        name: 'excel',
        component: Excel,
        meta: {layout: panelDefaultLayout},
        beforeEnter: guards.paranGuards,

    },
    {
        path: '/panel/categories',
        name: 'categories',
        component: categories,
        meta: {layout: panelDefaultLayout},
        beforeEnter: guards.paranGuards,

    },
    {
        path: '/panel/customers',
        name: 'customer',
        component: customer,
        meta: {layout: panelDefaultLayout},
        beforeEnter: guards.paranGuards,

    },
    {
        path: '/panel/customers/answer/:id',
        name: 'answer',
        component: Answer,
        meta: {layout: panelDefaultLayout},
        beforeEnter: guards.paranGuards,

    },

    {
        path: '/panel/listQuestions',
        name: 'listQuestions',
        component: ListQuestions,
        meta: {layout: panelDefaultLayout},
        beforeEnter: guards.paranGuards,

    },
    {
        path: '/panel/CreateQuestions/:codeId',
        name: 'createQuestions',
        component: CreateQuestions,
        meta: {layout: panelDefaultLayout},
        beforeEnter: guards.paranGuards,

    },
    {
        path: '/panel/settings',
        name: 'settings',
        component: Settings,
        meta: {layout: panelDefaultLayout},
        beforeEnter: guards.paranGuards,

    },
    {
        path: '/panel/reset',
        name: 'reset',
        meta: {layout: panelDefaultLayout},
        component: () => import(/* webpackChunkName: "notifications" */ '../panel/components/Resets/index.vue'),
        beforeEnter: guards.MustBeNotShowButtonGauard,
        props: true,
    },

    {
        path: '/panel/roles',
        name: 'roles',
        meta: {layout: panelDefaultLayout},
        component: () => import(/* webpackChunkName: "notifications" */ '../panel/components/Roles/index.vue'),
        beforeEnter: guards.MustBeNotShowButtonGauard,
        props: true,
    },
    {
        path: '/panel/roles/create',
        name: 'roleCreate',
        meta: {layout: panelDefaultLayout},
        component: () => import(/* webpackChunkName: "notifications" */ '../panel/components/Roles/create.vue'),
        beforeEnter: guards.MustBeNotShowButtonGauard,
        props: true,
    },
    {
        path: '/panel/agents',
        name: 'agentIndex',
        meta: {layout: panelDefaultLayout},
        component: () => import(/* webpackChunkName: "notifications" */ '../panel/components/agents/index.vue'),
        beforeEnter: guards.MustBeNotShowButtonGauard,
        props: true,
    },
    {
        path: '/panel/agents/create',
        name: 'agentCreate',
        meta: {layout: panelDefaultLayout},
        component: () => import(/* webpackChunkName: "notifications" */ '../panel/components/agents/create.vue'),
        beforeEnter: guards.MustBeNotShowButtonGauard,
        props: true,
    },
    {
        path: '/panel/agents/edit/:id',
        name: 'agentEdit',
        meta: {layout: panelDefaultLayout},
        component: () => import(/* webpackChunkName: "notifications" */ '../panel/components/agents/edit.vue'),
        beforeEnter: guards.MustBeNotShowButtonGauard,
        props: true,
    },
    {

        path: '/panel/discount',
        name: 'discount',
        component: Discount,
        meta: {layout: panelDefaultLayout},
        beforeEnter: guards.paranGuards,
    },
    {
        path: '/panel/transactions',
        name: 'transactions',
        meta: {layout: panelDefaultLayout},
        component: () => import(/* webpackChunkName: "notifications" */ '../panel/views/transactions/index.vue'),
        beforeEnter: guards.MustBeNotShowButtonGauard,
        props: true,
    },

]